import React from 'react'
import QRisultato from '../../libQuestionario/pages/QRisultato'
import { API_SERVICES } from '..'

const MRRisultato = () => {
  return <QRisultato
    homeRoute={API_SERVICES.MR.HOME_ROUTE}
    root={API_SERVICES.MR.ROOT}
  />
}

export default MRRisultato